module.exports = __webpack_public_path__ + "img/img18.cc5c13d8.png";